import { DesignerApplicationSteps } from "../../../__generated__/types";

export const WelcomeMessage = ({
  firstName,
  status,
  message,
}: {
  firstName: string;
  status?: DesignerApplicationSteps;
  message?: string;
}) => {
  return (
    <div className="dashboard-welcom-message">
      <h1 className="page-title font-title font-size-6">
        Welcome, {firstName} 👋🏻
      </h1>
      {message ? (
        <p>{message}</p>
      ) : status === DesignerApplicationSteps.CompleteApplication ? (
        <p>
          Your application is not yet complete. Finish the application to gain
          full-platform access.
        </p>
      ) : null}
    </div>
  );
};
